<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image002">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">联系我们</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
			<div class="conBg">
				<div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">联系我们</h2>
                    </div>
                    <ul class="sortList wow fadeInUp" id="anchor">						
						<li><router-link to="/contact">联系我们</router-link></li>
						<li class="active"><router-link to="/join">加入我们</router-link></li>
                    </ul>
					<div class="joinTop joinHead f16 color_f">
						<div class="joinName ellipsis">职位</div>
						<div class="joinType ellipsis">职位类别</div>
						<div class="joinAddress MultiLine">
							<div class="joinAddressCon">
								<p>工作地点</p>
							</div>
						</div>
						<div class="joinPeople">联系人</div>
						<div class="joinPhone">联系电话</div>
						<div class="joinTime">发布日期</div>
						<div class="joinOpen">操作</div>
					</div>
					<el-collapse class="joinList" v-model="activeIndex" accordion v-if="joinList.length">
						<el-collapse-item :name="item.id" v-for="item in joinList" :key="item.id">
							<template slot="title">
								<div class="joinHead f16 color6">
									<div class="joinName ellipsis color3">{{item.job_name}}</div>
									<div class="joinType ellipsis color3">{{item.job_category_text}}</div>
									<div class="joinAddress MultiLine">
										<div class="joinAddressCon">
											<p>{{item.work_location}}</p>
										</div>
									</div>
									<div class="joinPeople">{{item.contacts}}</div>
									<div class="joinPhone">{{item.phone}}</div>
									<div class="joinTime">{{item.release_time}}</div>
									<div class="joinOpen">
										<template v-if="item.id == activeIndex">收起 ↑</template>
										<template v-else>查看详细 +</template>
									</div>
								</div>
							</template>
							<div class="joinText f16 color6">
								<div class="mobile">
									<p><strong>职业类别：</strong>{{item.job_category_text}}</p>
									<p><strong>工作地点：</strong>{{ item.work_location }}</p>
									<p><strong>联系人：</strong>{{item.contacts}}</p>
									<p><strong>联系电话：</strong>{{item.phone}}</p>
									<p><strong>发布日期：</strong>{{item.release_time}}</p>
								</div>
								<div v-if="item.job_req_data.length">
									<h3>岗位要求</h3>
									<p v-for="(a, i) in item.job_req_data" :key="i">{{ a.value_1 }}</p>
								</div>
								<br>
								<div v-if="item.job_res_data.length">
									<h3>岗位职责</h3>
									<p v-for="(a, i) in item.job_res_data" :key="i">{{ a.value_1 }}</p>
								</div>
								<!-- <h3>岗位职责：</h3>
								<p>1. 负责公司AI产品开发、维护、文档编写等工作 ； </p>
								<p>2. 参与公司项目中相关部分的业务对接、用户调研、数据分析、模型构建、效果验证等工作；</p>
								<p>3. 与公司同事合作，推进数据模型、数据产品的开发、上线、运营等工作；</p>
								<p>4. 参与公司产品、项目推进过程中的相关规范性文档的梳理和撰写工作。</p>
								<br>
								<h3>岗位要求:</h3>
								<p>1. 计算机、自动化、统计学、数学等相关专业本科及以上学历，三年以上相关工作经验 ；</p>
								<p>2. 精通Python3，熟练使用常用库（如numpy、pandas），同时掌握Java开发者优先；</p>
								<p>3. 熟悉常用的数据分析挖掘方法及工具，能够熟练处理各类数据源及类型数据，挖掘数据内在信息；</p> -->
							</div>
						</el-collapse-item>
					</el-collapse>
					<el-empty v-else description="暂无内容"></el-empty>
				</div>
			</div>
		</div>
		<Message></Message>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import BanIn from '@/components/BanIn.vue'
	import Message from '@/components/Message.vue'
	import Footer from '@/components/Footer.vue'
	import { WOW } from 'wowjs'
	import home from '../api/home'
	export default {
		name: 'Case',
		components: {
			Header,
			BanIn,
			Message,
			Footer
		},
		data() {
			return {
				headType:3,
				mapIcon:require('@/assets/images/icon/mapIcon.png'),
				activeIndex: null,
				joinList: []
			}
		},
		watch: {
			joinList () {
				this.$nextTick(()=>{
					new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
				})
			}
		},
		mounted() {
			this.$nextTick(()=>{
				new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
			});
			this.getlist();
		},
		methods:{
			getlist(){
				home.joinList().then((res)=>{
					if (res.code === 1) {
						this.joinList = res?.data.rows
					} else {
						this.$toast(res.msg)
					}
				});
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/contact.scss';
</style>